<template>
  <div class="body container-fluid">
    <Navbar />

    <div
      class="check-container"
      :dir="$i18n.locale === 'fa' || $i18n.locale === 'ar' ? 'rtl' : 'ltr'"
    >
      <div class="check-card">
        <h2>{{ $t('checkInquiry.title') }}</h2>

        <form @submit.prevent="submitInquiry">

          <div class="form-group">
            <label>{{ $t('checkInquiry.amount') }}</label>
            <input v-model="form.amount" type="number" class="form-input" required />
          </div>

          <div class="form-group">
            <label>{{ $t('checkInquiry.checkNumber') }}</label>
            <input v-model="form.checkNumber" class="form-input" required />
          </div>

          <div class="form-group">
            <label>{{ $t('checkInquiry.accountNumber') }}</label>
            <input v-model="form.accountNumber" class="form-input" required />
          </div>

          <div class="form-group">
            <label>{{ $t('checkInquiry.bankName') }}</label>
            <input v-model="form.bankName" class="form-input" required />
          </div>

          <div class="form-group">
            <label>{{ $t('checkInquiry.branchName') }}</label>
            <input v-model="form.branchName" class="form-input" />
          </div>

          <div class="form-group">
            <label>{{ $t('checkInquiry.dueDate') }}</label>
            <input v-model="form.dueDate" type="date" class="form-input" required />
          </div>

          <div class="form-group">
            <label>{{ $t('checkInquiry.reason') }}</label>
            <input v-model="form.reason" class="form-input" />
          </div>

          <div class="form-group">
            <label>{{ $t('checkInquiry.payee') }}</label>
            <input v-model="form.payee" class="form-input" />
          </div>

          <button class="submit-btn" type="submit">
            {{ $t('checkInquiry.submit') }}
          </button>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";

export default {
  name: "CheckInquiry",

  components: { Navbar },

  data() {
    return {
      form: {
        amount: "",
        checkNumber: "",
        accountNumber: "",
        bankName: "",
        branchName: "",
        dueDate: "",
        reason: "",
        payee: ""
      }
    };
  },

  methods: {
    submitInquiry() {
      console.log("Check inquiry data:", this.form);
    }
  }
};
</script>

<style>
.check-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  min-height: 80vh;
  background: var(--bg);
}

.check-card {
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 30px;
  width: 100%;
  max-width: 500px;
  color: var(--text);
}

.check-card h2 {
  margin-bottom: 20px;
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 5px;
  color: var(--text);
}

.form-input {
  padding: 10px;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--input-bg);
  color: var(--text);
}

.submit-btn {
  width: 100%;
  padding: 12px;
  background: var(--primary);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 10px;
}

.submit-btn:hover {
  opacity: 0.9;
}
</style>
